import { render } from "./technologyOffline.vue?vue&type=template&id=482a0c1a&scoped=true"
import script from "./technologyOffline.vue?vue&type=script&lang=js"
export * from "./technologyOffline.vue?vue&type=script&lang=js"

import "./technologyOffline.vue?vue&type=style&index=0&id=482a0c1a&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-482a0c1a"]])

export default __exports__